/** Path of the consulting page, shared by the router, navigation and prerendering. */
export const CONSULTING_PATH = '/poradenstvi';

/** Path of the training page, shared by the router, the home page banner and prerendering. */
export const TRAINING_PATH = '/skoleni';

/** Path of the AI services page, shared by the router, the header services menu and prerendering. */
export const AI_SERVICES_PATH = '/ai-sluzby';

/** Public address of the site, used for canonical URLs and structured data. */
export const BASE_URL = 'https://slp.blue';
